import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ChevronFirst: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm17 18-6-6 6-6' }],
    ['path', { d: 'M7 6v12' }],
  ],
];

export default ChevronFirst;
